import { render, staticRenderFns } from "./TwoColumnsContainer.vue?vue&type=template&id=60d0a7b8&scoped=true"
import script from "./TwoColumnsContainer.vue?vue&type=script&lang=ts"
export * from "./TwoColumnsContainer.vue?vue&type=script&lang=ts"
import style0 from "./TwoColumnsContainer.vue?vue&type=style&index=0&id=60d0a7b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0a7b8",
  null
  
)

export default component.exports